import {
  HStack,
  Separator,
  Spacer,
  Stack,
} from "@chakra-ui/react"
import { Text } from "@/components"
import { DealGrant } from "@/types"
import { format } from "@/utils"

const getGrantBg = (type: string) => {
  switch (type) {
    case "iso":
      return "grant.100";
    case "nso":
      return "grant.200";
    case "shares":
      return "grant.400";
    default:
      return "white";
  }
}

export const GrantBox = ({ grant }: { grant: DealGrant }) => {
  return (
    <Stack w="30%" minW="200px" p={5} borderRadius={10} bg={getGrantBg(grant.grantType)} boxShadow="md">
      <HStack w="100%">
        <Text fontSize="md">{grant.description || `Grant #${grant.grantNumber}`}</Text>
        <Spacer />
        <Text fontSize="md" fontWeight="bold">{grant.grantType.toUpperCase()}</Text>
      </HStack>
      <Text fontSize="md" fontWeight="bold">
        {`${format(grant.vested.toLocaleString())} at ${format(grant.price.toFixed(4))}`}
      </Text>
      <Separator />
      <Stack w="100%" mt={5}>
        <Text fontSize="sm">Vested Shares</Text>
        <Text fontSize="2xl" fontWeight="bold">{grant.vested.toLocaleString()}</Text>
      </Stack>
    </Stack>
  )
}
